// extracted by mini-css-extract-plugin
module.exports = {"messagesBadge":"MobileMessagesBadge_messagesBadge__ByXPp"};